
/**
 * @import internal modules
 */
import Menu from "@apps-shared/menu/container";
import Header from "@apps-shared/header/component";

import ClassFive from "@apps-widgets/classFive/component";
import InfosItems from "@apps-widgets/info-items/component";
import Helping from "@apps-widgets/helping/component";
import * as Utils from '@root-utils/index';
/**
 * @import external modules
 */

import * as React from "react";
import { pure } from 'recompose';
import * as Scrollbars from 'react-custom-scrollbars';
import * as Lodash from 'lodash';



// component
const Component: React.FunctionComponent<any> = (props: InterfaceLayout<string>): JSX.Element =>{
    
    const { children,realTime,  items , menu ,timerShow, itemsModal, onCloseItems} = props;

    const onSliderBarre = () => Utils.hideShowlayout();

    const [openModal, setOpenModal] = React.useState(false);

    const onClosehelping = ( event: any) => setOpenModal(false);

    /**
     * @function onOpenModal
     * @param event 
     */
    const onOpenModal = ( event: any) => setOpenModal(true);
    

    const [ dataModaleFive, setDataModaleFive] = React.useState<object>({});


    const onCallModalClassFive = (param: any) => (event: any) => { 

        setDataModaleFive(param) ;
    }
    
    const onCloseItem = ( event: any) => setDataModaleFive({});
    
    return(
        <div className="layout " >
            
            { openModal && <Helping helping={openModal} onClose={onClosehelping}/> }

            {!Lodash.isEmpty(itemsModal) && <InfosItems onCloseItems={onCloseItems} itemsModal={itemsModal}/>}
            
            {!Lodash.isEmpty(dataModaleFive) && <InfosItems onCloseItems={onCloseItem} itemsModal={dataModaleFive}/>}

            <div className="header-tollsense">
                <Header {...props} timerShow={timerShow} onOpenModal={onOpenModal}/>
            </div>
            <main className="wrapper">
                { menu &&  <section className="left menu menuRight " id="menu">
                    < Menu classnames="menu-nav" {...props}/>    
                </section> }
                <section className="left main mainRight" id="main">
                    <div className="full-width-content">{children}</div>
                    {
                        realTime &&
                        <div className="layout-five layout-one" id="layoutFive">
                            <div className="footer-top">
                                <div className="footer-top-content">
                                    <span> Last class 5 </span>
                                    <span onClick={onSliderBarre}>
                                        <svg width="16" height="3" viewBox="0 0 16 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="16" height="3" fill="white"/>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                            <section id="columns" className="with-3-columns">
                                <div className="cart-items">
                                    <div className="cart-content cart-layout-content footer-top-content">
                                        
                                        <Scrollbars.default autoHide={true}>

                                           
                                            { items &&  items
                                              .map((item: any, index:number)=><ClassFive onOponFive={onCallModalClassFive(item)} items={item} key={index}/>)
                                            }
                                              
                                             
                                        </Scrollbars.default>
                                    
                                    </div>
                                </div>
                            </section>
                        </div>}
                </section>
            </main>
        </div>
    )
}
// interface 
export interface InterfaceLayout<T>{
    classnames: T,
    children:any,
    realTime?:boolean,
    onSliderBarre?:any,
    importImage?:boolean,
    onClose?:any,
    onDropFile?:any,
    items?:any,
    onCloseImages?:any,
    menu?:boolean,
    timerShow?:boolean,
    itemsModal?:any,
    onCloseItems?:any
}
/**
 * DefaultProps values
 */
Component.defaultProps= {

}


export default pure(Component);


// WEBPACK FOOTER //
// ./src/apps/components/@shared/layout/component.tsx